import { CartItemDto } from "../../dto/cart/cartItemDto";
import CartItem from "../../dto/vending/CartItemDto";
import { MemberVoucherResDto } from "../../dto/vending/MemberVoucherResDto";
import cartType, { CartState, ICartAction } from "./cart.type";

const initialState: CartState = {
  cartItem: {},
  memberVoucher: undefined,
  cartItems: [],
};

const updateCachedCart = (cartItem: CartItem) => {
  const codeStore = localStorage.getItem("code");
  localStorage.setItem(`cart_${codeStore}`, JSON.stringify(cartItem));
};

const updateCachedCarts = (cartItems: CartItemDto[]) => {
  const codeStore = localStorage.getItem("code");
  localStorage.setItem(`carts_${codeStore}`, JSON.stringify(cartItems));
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action: ICartAction) => {
  let cartItems = state.cartItems || new Array<CartItemDto>();
  switch (action.type) {
    // Product => Cart
    case cartType.CART.UPDATE_CART_ITEM: {
      let itemCart = action.payload as CartItem;
      // Update cart cached
      updateCachedCart(itemCart);
      return {
        ...state,
        cartItem: itemCart,
      };
    }
    // Init App => Cart
    case cartType.CART.UPDATE_WHOLE_CART: {
      return {
        ...state,
        cartItem: action.payload as CartItem,
      };
    }
    case cartType.CART.LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case cartType.CART.GET_MEMBER_VOUCHER_SUCCESS: {
      return {
        ...state,
        memberVoucher: action.payload as MemberVoucherResDto,
        isLoading: false,
      };
    }
    case cartType.CART.GET_MEMBER_VOUCHER_FAIL: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case cartType.CART.CLEAR_MEMBER_VOUCHER: {
      return {
        ...state,
        memberVoucher: undefined
      };
    }

    case cartType.CARTS.ADD_TO_CART: {
      let needAddCartItem = action.payload as CartItemDto;
      let finding = cartItems.find((e) => e.product?.id === needAddCartItem?.product?.id);
      if (finding) {
        let index = cartItems.indexOf(finding);
        let newQuantity = finding.quantity + needAddCartItem?.quantity;
        if (newQuantity > 0) {
          cartItems[index] = new CartItemDto(
            finding.product,
            newQuantity,
          );
        } else {
          cartItems.splice(index, 1);
        }
      } else {
        cartItems.push(
          new CartItemDto(
            needAddCartItem?.product,
            needAddCartItem?.quantity,
          )
        );
      }
      let newCartItems = new Array<CartItemDto>();
      newCartItems.push(...cartItems);
      // Update cart cached
      updateCachedCarts(newCartItems);
      return {
        ...state,
        cartItems: newCartItems,
      };
    }

    // Update cart item qty
    case cartType.CARTS.UPDATE_CART_ITEM_QTY:
      let index = action.payload.cartItemIndex;
      let newQty = action.payload.newQuanity;
      let temp = [...cartItems];
      if (newQty > 0) {
        temp[index].quantity = newQty;
      } else {
        temp[index] = undefined;
        temp = temp.filter((e) => e !== undefined);
      }
      updateCachedCarts(temp);
      return {
        ...state,
        cartItems: temp,
      };

    // Clean data
    case cartType.CARTS.CLEAR_DATA_CARTS:
      updateCachedCarts([]);
      return {
        ...state,
        cartItems: [],
      };

    default:
      return state;
  }
};
